<template>
  <button
    class="w-full pb-8 text-left"
    data-test="search-with-ai"
    type="button"
    @click="emit('click')"
  >
    <span
      class="bg-static-ai-low body-1-bold text-onaction-ai-mid flex items-center gap-8 rounded-sm p-8"
    >
      <IconCommentWithSparkles size="24" />
      {{ i18n(translations.searchWithAi) }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconCommentWithSparkles } from '@ds/icons/IconCommentWithSparkles'

import translations from '../../SearchBar.translations'

const i18n = useI18n()
const emit = defineEmits<{ click: [] }>()
</script>
